import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthHeaderName, ApplicationType } from 'shared/openapi/models';

export const APP_TYPE_CONFIG: InjectionToken<ApplicationType> = new InjectionToken('APP_TYPE_CONFIG');

@Injectable()
export class AppTypeInterceptor implements HttpInterceptor {
	constructor(private appType: ApplicationType) {}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const req = request.clone({
			setHeaders: {
				[AuthHeaderName.XAppType]: this.appType,
			},
		});

		return next.handle(req);
	}
}
